<main class="container py-4">
    <app-nav-header pageTitle="Policy FAQ" pageTitleCss="text-black"></app-nav-header>

    <section class="pt-3">
        <!-- <div class="mb-4 text-justify text-sm font-semibold">You can view and download the full policy FAQ here.</div> -->

        @if (isLoading) {
            <div class="grid place-items-center py-4">
                <mat-spinner></mat-spinner>
            </div>
        }
        <pinch-zoom backgroundColor="rgba(0,0,0,0)">
            <div class="h-[460px] w-full">
                <pdf-viewer
                (after-load-complete)="callBackFn($event)"
                [original-size]="false"
                [render-text]="true"
                [show-borders]="true"
                [src]="pdfSrc"
                class="h-full"
                zoom-scale="page-width"></pdf-viewer>
            </div>
        </pinch-zoom>

        <!-- <div class="pt-14">
            <a [href]="pdfSrc" class="w-full" download mat-stroked-button type="button">Download Full Policy FAQ</a>
        </div> -->
    </section>
</main>
